module.exports = __webpack_public_path__ + "img/logo.86451bf6.svg";